<div class="tire-dot-number">
    <div class="tire-dot-number-header mb-0">
        <div class="ui-g-12 flex-between-center p-0">
            <div class="flex-start-center width-100p">
                <div class="ml-2 width-100p p-relative font-600 font-16 mt-1">Pricing Rules</div>
            </div>
            <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog('close')"></i>
        </div>
    </div>

    <div class="tire-dot-number-body">
        <app-parts-pricing [isOpenAsDialog]="isOpenAsDialog" [isReadOnly]="isReadOnly" [selectedMatrix]="selectedMatrix"
        (onMatrixChange)="onMatrixChange($event)"></app-parts-pricing>
    </div>

    <!-- <div class="ui-g-12 flex-between-end dialog-footer part-footer border-top">
        <div class="tire-dot-number-footer d-flex justify-content-end width-100p">
            <button id="part-cancel-btn"
                class="btn btn-white btn-border pointer btn-submit ml-2" (click)="closeDialog('close')">Cancel</button>

            <button id="part-save-btn" class="btn btn-primary btn-submit pointer ml-2" (click)="save()">
                <span class="font-bold">Save</span>
            </button>
        </div>
    </div> -->
</div>